<template>
  <ErrorBoundary>
    <StageTeaser
      :image="mgnlPropsWithBtnColors.image"
      :mobile-image="mgnlPropsWithBtnColors.mobileImage"
      :image-title="mgnlPropsWithBtnColors.imageTitle"
      :image-link="mgnlPropsWithBtnColors.imageLink"
      :top-title="mgnlPropsWithBtnColors.topTitle"
      :top-title-color="mgnlPropsWithBtnColors.topTitleColor"
      :title="mgnlPropsWithBtnColors.title"
      :title-color="mgnlPropsWithBtnColors.titleColor"
      :alt="mgnlPropsWithBtnColors.alt"
      :sub-text="mgnlPropsWithBtnColors.subText"
      :sub-text-color="mgnlPropsWithBtnColors.subTextColor"
      :background-color="mgnlPropsWithBtnColors.backgroundColor"
      :heading-tag="mgnlPropsWithBtnColors.headingTag"
      :position="mgnlPropsWithBtnColors.position"
      :image-position="mgnlPropsWithBtnColors.imagePosition"
      :image-load-type="(mgnlPropsWithBtnColors.imageLoadType as ('eager' | 'lazy'))"
      :cta-link="mgnlPropsWithBtnColors.ctaLink"
      :cta-text-color="mgnlPropsWithBtnColors.ctaTextColor"
      :button-color="mgnlPropsWithBtnColors.buttonColor"
      :border-color="mgnlPropsWithBtnColors.borderColor"
      :data-ab-id="mgnlProps?.dataABId"
      :legal-text="mgnlPropsWithBtnColors.legalText"
      :legal-title="mgnlPropsWithBtnColors.legalTitle"
      :enable-legal-disclaimer="mgnlPropsWithBtnColors.enableLegalDisclaimer"
      :title-or-subtitle="mgnlPropsWithBtnColors.titleOrSubtitle"
      :int-link-param="mgnlPropsWithBtnColors.intLinkParam"
      :aspect-ratio="mgnlPropsWithBtnColors.aspectRatio"
      :mobile-aspect-ratio="mgnlPropsWithBtnColors.mobileAspectRatio"
    />
  </ErrorBoundary>
</template>

<script lang="ts" setup>
import StageTeaser from '~/components/Shared/Teaser/Stage/StageTeaser.vue';
import { StageTeaserBuilder, WrapperProps } from '~/components/Shared/Teaser/Stage/StageTeaser.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps({
  ...WrapperProps, pageLink: String, ctaText: String, ctaTargetMode: String, pdfLinkInDam: Object, showCtaAsPdf: Boolean,
});
const {
  topTitleColor, titleColor, subTextColor, backgroundColor,
} = toRefs(props);

const mgnlProps = {
  ...StageTeaserBuilder.build(props),
  topTitleColor: magnoliaGetters.getHexColor(topTitleColor?.value),
  titleColor: magnoliaGetters.getHexColor(titleColor?.value),
  subTextColor: magnoliaGetters.getHexColor(subTextColor?.value),
  backgroundColor: magnoliaGetters.getHexColor(backgroundColor?.value),
};

if (props.pageLink && !props.ctaLink) {
  magnoliaGetters.migratePageLinkToCtaLink(mgnlProps, props);
}

const mgnlPropsWithBtnColors = {
  ...mgnlProps,
  ctaTextColor: mgnlProps.ctaLink?.[0]?.ctaTextColor ? magnoliaGetters.getHexColor(mgnlProps.ctaLink?.[0]?.ctaTextColor) : '#ffffff',
  buttonColor: mgnlProps.ctaLink?.[0]?.buttonColor ? magnoliaGetters.getHexColor(mgnlProps.ctaLink?.[0]?.buttonColor) : '#3c3c3b',
  borderColor: mgnlProps.ctaLink?.[0]?.borderColor ? magnoliaGetters.getHexColor(mgnlProps.ctaLink?.[0]?.borderColor) : '#3c3c3b',
};
</script>
